import useIsAdminSeller from '../../../../../stores/ShowUnavailableProducts/hooks/useIsAdminSeller';
import useSharedEntities from '../../../../shared-entities/hooks/useSharedEntities';
import { useAbility } from '../../../../users/AbilityContext';
import { CatalogSectionSortCriterionEnum } from '../../../enums/catalogSectionSortCriterion.enum';
import { CatalogViewGroupBy } from '../view/catalogView.types';
import { useCatalogEffectiveView } from './useCatalogEffectiveView';

interface UseCatalogDragEnabledParams {
  catalogId: string;
  isOfflineMode: boolean;
  canPersist: boolean;
}

export const useCatalogDragEnabled = ({
  catalogId,
  isOfflineMode,
  canPersist,
}: UseCatalogDragEnabledParams): boolean => {
  const ability = useAbility();
  const { isPublicAccess } = useSharedEntities({});
  const isAdminSeller = useIsAdminSeller();

  const { sortCriterion, groupBy, isSettled } = useCatalogEffectiveView({ catalogId, canPersist });

  return (
    isSettled &&
    sortCriterion === CatalogSectionSortCriterionEnum.MANUAL &&
    groupBy === CatalogViewGroupBy.MANUAL &&
    ability.can('update', 'catalog-products') &&
    !isOfflineMode &&
    !isPublicAccess &&
    !isAdminSeller
  );
};
